import { api } from "aldoo-ra/API"

const downloadablesAPI = api("downloadables")

/** Public metadata + latest version + caller eligibility. */
export const GetDownloadable = async (id) => downloadablesAPI({ get: { id } })

/** Full changelog (gated by the same eligibility as the download). */
export const GetChangelog = async (id, params = {}) =>
  downloadablesAPI({ changelog: { id, ...params } })

/**
 * Authorize a download and get a short-lived signed URL.
 * @returns {Promise<{result, url, version, fileName, size, expiresIn}>}
 */
export const GetDownloadLink = async (id, version) =>
  downloadablesAPI({ get_link: { id, ...(version ? { version } : {}) } })
